import React from "react";
import { getCurrentLanguage, useTranslation } from "locales";
import { getPrivacyContent } from "./content";
import "./style.scss";

function PagePrivacy() {
  // Subscribe to language changes so the page re-renders on toggle.
  useTranslation();
  const C = getPrivacyContent(getCurrentLanguage());

  return (
    <div className="page-legal">
      <div className="page-legal__container">
        <h1>{C.title}</h1>
        <p className="page-legal__updated">{C.lastUpdated}</p>
        {C.body}
      </div>
    </div>
  );
}

export default PagePrivacy;
